import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { onePageCheckoutDeliveryMethodStyles } from "@dana/Overrides/Widgets/OnePageCheckout/OnePageCheckoutDeliveryMethod";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

onePageCheckoutDeliveryMethodStyles.container = mergeToNew(onePageCheckoutDeliveryMethodStyles.container, {
    gap: 0,
    css: css`
        background: ${themeBackgrounds.white};
    `,
});

onePageCheckoutDeliveryMethodStyles.headingContainer = mergeToNew(
    onePageCheckoutDeliveryMethodStyles.headingContainer,
    {
        gap: 0,
        css: css`
            background: ${themeBackgrounds.lightGray};
            padding: 16px;
        `,
    },
);

onePageCheckoutDeliveryMethodStyles.titleText = mergeToNew(onePageCheckoutDeliveryMethodStyles.titleText, {
    size: fontSizes.medium,
    lineHeight: lineHeights.medium,
    css: css`
        margin-bottom: 0;
        letter-spacing: normal;
    `,
});

onePageCheckoutDeliveryMethodStyles.fulfillmentMethodGridItem = mergeToNew(
    onePageCheckoutDeliveryMethodStyles.fulfillmentMethodGridItem,
    {
        css: css`
            padding: 16px;
            position: relative;
        `,
    },
);

onePageCheckoutDeliveryMethodStyles.servicesGridContainer = mergeToNew(
    onePageCheckoutDeliveryMethodStyles.servicesGridContainer,
    {
        gap: 10,
    },
);

onePageCheckoutDeliveryMethodStyles.servicesGridItem = mergeToNew(
    onePageCheckoutDeliveryMethodStyles.servicesGridItem,
    {
        width: [12, 6, 4, 4, 4],
        css: css`
            &.carrier-service {
                flex-direction: column;
                gap: 4px;
            }
        `,
    },
);

onePageCheckoutDeliveryMethodStyles.orderInstuctionTooltip = mergeToNew(
    onePageCheckoutDeliveryMethodStyles.orderInstuctionTooltip,
    {
        mergeCss: true,
        cssOverrides: {
            tooltipBody: css`
                font-weight: ${fontWeights.regular};
                width: 100%;
            `,
            tooltipContainer: css`
                width: 175px;
                right: 0; 
                left: auto;
                transform: translateX(16px);
            `,
            tooltipWrapper: css`
                position: absolute;
                top: 19px;
                margin-left: 4px;
            `,
            tooltipArrow: css`
                right: 0;
                left: auto;
                transform: translateX(-18px);
            `
    	},  
    }
)
